<template>
  <div class="wrapp flex">
    <div class="bb no-scrollbar flex-treble" :style="{'overflow-y':scrollTop>130?'auto':'hidden'}">
      <div style="min-height:100vh">
        <div
          class="section"
          :style="{'border-left': '5px solid '+item.mainColor}"
          v-for="(item,index) in imgList.category"
          :key="index"
        >
          <div class="head">
            <span class="icon" :class="'icon-'+item.icon" :style="{background:item.mainColor}"></span>
            {{item.title}}
          </div>
          <div class="bady grid col-item">
            <template v-for="(ite,ind) in imgList.list">
              <div
                class="item min"
                style="display:inline-block"
                v-if="ite.selected&&ite.category == item.id"
                :key="ind"
              >
                <ImgWrapp
                  @dragstart.native="dragstart(ite)"
                  :imgLink="ite.link"
                  :ask="ite.ask"
                  :isClose="true"
                  :imgId="ite.id"
                  :bgColor="item.mainColor"
                  :info="{id:ite.id}"
                  @bindClick="selectRemove"
                  :isDrag="true"
                />
              </div>
            </template>
          </div>
        </div>
        
      </div>
    </div>
    <div class="left-box flex-twice">
      <div class="section section1 animate" :class="{'active':scrollTop>130}">
        <div class="head my-scrollbar">
          <vue-scroll :ops="ops" ref="sliderWrapp">
            <div class="nav-bar">
              <div
                class="item"
                :class="navId==index?'active':''"
                v-for="(item,index) in seletedImgList"
                :key="index"
                @click="changeNav(index)"
              >{{item.category+'-'+item.name+'('+item.list.length+'/'+item.limit+')'}}</div>
            </div>
          </vue-scroll>
        </div>
        <div class="bady">
          <div
            class="border-1"
            @dragenter="dragenter"
            @dragover="dragover"
            @dragleave="dragleave"
            @drop="drop"
          >
            <div class="border-2 my-scrollbar grid col-4" :style="{'borderColor':dragIn?'red':''}">
              <template v-for="(ite,ind) in seletedImgList[navId].list">
                <div class="item" :key="ind">
                  <ImgWrapp
                    :imgLink="ite.link"
                    :ask="ite.ask"
                    :imgId="ite.id"
                    :isDelete="true"
                    :bgColor="seletedImgList[navId].bgColor"
                    @bindClick="selectDelete"
                    :info="{id:ite.id}"
                    :showAsk="false"
                  />
                </div>
              </template>
              <div
                class="bg no-select flex-sub"
                v-if="seletedImgList[navId].limit>seletedImgList[navId].list.length"
              >
                <i class="icon-file-picture"></i>
                <div>
                  给 {{seletedImgList[navId].category+'-'+seletedImgList[navId].name}} 拖入你
                  想要的照片吧
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgWrapp from "../components/imgWrapp";
import navVue from "../components/nav.vue";
export default {
  props: { scrollTop: Number },
  components: { ImgWrapp },
  data() {
    return {
      navId: 0,
      dragIn: false,
      dragItem: null,
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          keepShow: false
        },
        bar: {
          hoverStyle: true,
          onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
          background: "rgba(127, 143, 164, 0.31)",
          size: "5px"
          // disable: true
        },
        rail: {
          gutterOfEnds: "1px",
          gutterOfSide: "1px"
        }
      }
    };
  },
  methods: {
    // 移除拖动加入
    selectDelete(type, data) {
      let _this = this;
      this.$store.commit("removeSelectImg", {
        navId: _this.navId,
        id: data.info.id
      });
    },
    //移除选择
    selectRemove(type, data) {
      this.$store.commit("selecteImg", {
        data: false,
        id: data.info.id
      });
    },
    changeNav(index) {
      //切换相册
      this.navId = index;
    },
    // 拖动开始
    dragstart(data) {
      this.dragItem = data;
    },
    dragenter(e) {
      if (!this.$store.getters.getCanRevise) return;
      e.preventDefault();
      this.dragIn = true;
    },
    dragover(e) {
      if (!this.$store.getters.getCanRevise) return;
      e.preventDefault();
      this.dragIn = true;
    },
    dragleave(e) {
      e.preventDefault();
      this.dragIn = false;
    },
    drop(e) {
      e.preventDefault();
      if (!this.$store.getters.getCanRevise) return;
      var imgId = this.dragItem.id;

      this.dragIn = false;

      // 判断是否达到限制
      if (
        this.seletedImgList[this.navId].limit <=
        this.seletedImgList[this.navId].list.length
      ) {
        let element = this.seletedImgList[this.navId];
        this.$my_message.show({
          type: "err",
          title: "产品已满",
          btns: ["我知道了"],
          data: `
              <div class='text-20'><span class='text-orange'>${element.category +
                "-" +
                element.name}</span>已添加满</div><div class='text-20'>无法继续添加</div>
                `,
          success: function(data) {
            console.log("确认支付");
          },
          cancel: function(data) {
            console.log("取消");
          }
        });
        return;
      }

      // 判断此照片是否被选择
      if (this.dragItem.selectedList.length > 0) {
        let date;
        const element = this.seletedImgList[this.navId];
        if (this.dragItem.selectedList.includes(element.id)) {
          date = {
            type: "err",
            title: "已添加",
            btns: ["我知道了"],
            data: `
              <div class='text-20'>此照片已被添加到<span class='text-orange'>${element.category +
                "-" +
                element.name}</span></div><div class='text-20'>无法再次添加</div>
                `,
            success: function(data) {
              console.log("确认支付");
            },
            cancel: function(data) {
              console.log("取消");
            }
          };
          this.$my_message.show(date);
          return;
        }
      }

      // 拖动加入照片
      this.$store.commit("addSelectImg", {
        selectIndex: this.navId,
        id: imgId
      });
    }
  },
  computed: {
    imgList() {
      return this.$store.getters.getAllImgList;
    },
    seletedImgList() {
      return this.$store.getters.getSeletedImgList;
    }
  },
  onLoad() {}
};
</script>

<style lang="scss" scoped>
.wrapp {
  height: calc(100vh - 130px);
  min-height: 100vh;
  .bb {
    height: 100%;
    overflow: auto;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;

    &.active2 {
      padding-top: 500px;
    }
  }
  .left-box {
    margin-left: 20px;
    // width: 750px;
    position: relative;
  }
  .section {
    padding: 30px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid rgba(231, 233, 237, 1);
    margin-bottom: 20px;

    .head {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: rgba(53, 64, 82, 1);

      .icon {
        width: 24px;
        height: 24px;
        background: rgba(255, 120, 0, 1);
        border-radius: 8px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 12px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        font-size: 14px;
      }
      .nav-bar {
        border-bottom: 1px solid #ebebeb;
        overflow-x: auto;
        white-space: nowrap;
        .item {
          display: inline-block;
          padding: 20px 0;
          cursor: pointer;
          margin-right: 15px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: rgba(127, 143, 164, 1);
        }
        .active {
          font-weight: 500;
          color: rgba(43, 51, 62, 1);
          position: relative;
        }
        .active:after {
          content: "";
          display: block;
          position: absolute;
          width: 70%;
          left: 15%;
          height: 3px;
          background-color: #2b333e;
          bottom: 0;
        }
      }
    }
    .bady {
      margin-top: 20px;
      width: 100%;
      max-width: 1300px;
      .border-1 {
        border: 1px solid rgba(223, 227, 233, 1);
        border-radius: 3px;
        padding: 5px;
        position: relative;
        .bg {
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-size: 14px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: rgba(209, 215, 222, 1);
          width: 100%;
          height: 150px;
          flex-direction: column;
          i {
            font-size: 40px;
          }
          div {
            width: 165px;
            padding-top: 5px;
            line-height: 1.5;
          }
        }
      }
      .border-2 {
        border: 3px dashed rgba(206, 208, 218, 0.4);
        border-radius: 3px;
        min-height: 174px;
        padding: 9px 8px;
        z-index: 10;
        max-height: 500px;
        overflow-y: auto;
        overflow-x: hidden;
      }
      .item {
        margin-bottom: 10px;
      }
    }
  }
  .section1 {
    border-left: 5px solid #2b333e;
    padding: 0 20px 20px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    .head {
    // width: 700px;
      max-width: 100%;
      min-width: 100%;
      height: 60px;
      overflow-x: auto;
    }
    &.active {
      position: absolute;
      // width: 700px;
      top: 140px;
      left: 0;
      z-index: 10;
    }
  }
}
</style>
